module.exports = __webpack_public_path__ + "img/Training.7000f940.png";